// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__GNvPt","title":"BackImages_title__2bM_q","images":"BackImages_images__Q_At9"};